/*
 * @Author: Vanny
 * @Date: 2018-12-10 14:13:30
 * @LastEditors: Vanny
 * @LastEditTime: 2020-07-02 11:41:49
 * @Description: 顶部导航栏
 */
import React, { Component } from 'react';
import { Dropdown, Menu, Icon } from 'antd';

import { $t } from 'src/tools';
import styles from './index.less';

const PL: number = 16;
const FZ: number = 14;

interface IDataItem {
  name: string;
  path: string;
  left: number;
  width: number;
  'data-context-menu': string;
  key: string | number | undefined;
  data: {
    name: string;
    path: string;
  };
}
const defaultProps = {
  style: {},
  className: {},
  locale: {} as Record<string, string>,
  activeKey: 0 as string | number | undefined,
  dataSource: [] as IDataItem[],
  onChange: (key: string | number | undefined, item: object) => {},
};
const initialState = {
  more: [],
  display: [],
};

type DefaultProps = typeof defaultProps;
type Props = DefaultProps;
type State = Readonly<{
  display: IDataItem[];
  more: IDataItem[];
}>;

export class TabHeader extends Component<Props, State> {
  readonly state = initialState;
  itemRender = [] as Array<HTMLLIElement | null>;
  timer: NodeJS.Timeout | null;
  tabs = null as HTMLDivElement | null;

  constructor(props: Props) {
    super(props);
    this.timer = null;

    this.handleResize.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.timer = setTimeout(() => this.handleResize(), 100);
  }

  componentDidUpdate(prevProps: Props) {
    const { activeKey, dataSource, locale } = this.props;
    const { more } = this.state;
    if (
      JSON.stringify(locale) !== JSON.stringify(prevProps.locale) ||
      JSON.stringify(dataSource) !== JSON.stringify(prevProps.dataSource) ||
      more.find((v: IDataItem) => v.key === activeKey)
    ) {
      this.handleResize();
    }
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    window.removeEventListener('resize', this.handleResize);
  }

  render() {
    const { activeKey, style } = this.props;
    const { display, more } = this.state;

    if (!display || !display.length) {
      return <div />;
    }

    const menu: JSX.Element = (
      <Menu>
        {more.map((val: IDataItem) => (
          <Menu.Item key={val.key} onClick={this.handleClick(val)}>
            {this.getMenuItemName(val.data.name)}
          </Menu.Item>
        ))}
      </Menu>
    );

    const active = display.find((v: IDataItem) => v.key === activeKey) || ({} as IDataItem);

    return (
      <div ref={(c) => (this.tabs = c)} style={{ ...style }} className={styles.tabHeader}>
        <ul>
          {!!display &&
            !!display.length &&
            display.map((val: IDataItem, i) => (
              <li
                key={val.key}
                ref={(c) => (this.itemRender[i] = c)}
                className={val.key === activeKey ? styles.active : ''}
                onClick={this.handleClick(val)}
              >
                <span
                  data-path={val.data.path}
                  data-name={val.data.name}
                  data-context-menu={val['data-context-menu']}
                >
                  {this.getMenuItemName(val.data.name)}
                </span>
              </li>
            ))}
          {!!more && !!more.length && (
            <Dropdown overlay={menu}>
              <li key="more">
                {this.getMenuItemName('more')} <Icon type="down" />
              </li>
            </Dropdown>
          )}
        </ul>
        <div
          className={styles.barAnimated}
          style={{
            width: active.width,
            transform: `translate3d(${active.left}px, 0px, 0px)`,
          }}
        />
      </div>
    );
  }

  getMenuItemName = (key = '') => $t(key, this.props.locale);

  /**
   * 当 width / activeKey / dataSource 改变时重新调整UI
   *
   * 动态获取容器 width 根据 width 确定是否显示更多
   * 当 activeKey / dataSource 改变时重新排序更新UI
   */
  handleResize = () => {
    const { dataSource, activeKey } = this.props;

    const width: number = ((this.tabs || {}).clientWidth || 800) * 0.9;

    const display = [] as IDataItem[];
    const more = [] as IDataItem[];
    let w: number = 0;

    dataSource.forEach((val: IDataItem, index) => {
      val.key = val.key || index;

      const name = this.getMenuItemName(val.data.name) || '';
      const num = name.split(/[\u4e00-\u9fa5]+/).join('').length;
      val.width = PL * 2 + FZ * (name.length - num) + (FZ * num) / 2.4;
      w += val.width;
      w > width ? more.push(val) : display.push(val);
    });
    if (!!more.length) {
      let index: number = 0;
      const item: IDataItem[] = display.splice(display.length - 2, 2) || ([] as IDataItem[]);
      more.unshift(...item);
      const active: IDataItem = more.reduce(
        (tmp: IDataItem, v: IDataItem, i) => (v.key === activeKey ? ((index = i), v) : tmp),
        more[0] || ({} as IDataItem)
      );
      active.left = item[0].left;
      display.push(active);
      more.splice(index, 1);
    }
    this.setState({ display, more }, () => {
      const list = display.map((v, i) => ({
        ...v,
        left: (this.itemRender[i] || {}).offsetLeft || 0,
        width: (this.itemRender[i] || {}).clientWidth || 0,
      }));
      this.setState({ display: [...list] });
    });
  };

  /**
   * 当 tab 选中值改变时触发
   *
   * @param {object} e
   */
  handleClick = (e: IDataItem) => {
    const { activeKey, onChange } = this.props;
    return () => {
      if (e.key !== activeKey) {
        onChange && onChange(e.key, e);
      }
    };
  };
}
